import { PropsWithChildren, ReactNode } from 'react';

import type { DetailCardTone } from './types';

import { cn } from '@/lib/utils';

import { DETAIL_CARD_BODY_CLASS_NAME } from './consts';
import { DetailCardHeader } from './DetailCardHeader';

type DetailCardProps = PropsWithChildren<{
  title?: ReactNode;
  icon?: ReactNode;
  iconLabel?: ReactNode;
  tone?: DetailCardTone;
  action?: ReactNode;
  className?: string;
  contentClassName?: string;
}>;

export const DetailCard = (props: DetailCardProps) => {
  const {
    title,
    icon,
    iconLabel,
    tone,
    action,
    className,
    contentClassName,
    children,
  } = props;
  const hasHeader = !!title || !!action;
  const hasBody =
    children !== undefined && children !== null && children !== false;

  return (
    <section
      className={cn(
        'bg-card flex flex-col rounded-lg border shadow-xs',
        !hasHeader && cn(DETAIL_CARD_BODY_CLASS_NAME, contentClassName),
        className,
      )}
    >
      {hasHeader && (
        <>
          <DetailCardHeader
            title={title}
            icon={icon}
            iconLabel={iconLabel}
            tone={tone}
            action={action}
            hasBody={hasBody}
          />
          {hasBody && (
            <div className={cn(DETAIL_CARD_BODY_CLASS_NAME, contentClassName)}>
              {children}
            </div>
          )}
        </>
      )}
      {!hasHeader && children}
    </section>
  );
};
